import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface SimpleSpinnerProps {
    message: string;
}

/**
 * Simple spinner component that doesn't require Router context
 * Use this for loading states before Router is initialized
 */
export const SimpleSpinner: React.FC<SimpleSpinnerProps> = ({ message }) => {
    const theme = useTheme();

    const containerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: theme.colors.background,
        color: theme.colors.text.primary,
    };

    const spinnerStyle: React.CSSProperties = {
        width: '120px',
        height: '120px',
        marginBottom: '1rem',
    };

    const messageStyle: React.CSSProperties = {
        fontSize: theme.typography.fontSize.lg,
        color: theme.colors.text.secondary,
    };

    return (
        <div style={containerStyle}>
            <img
                src="/logo-spinner.gif"
                alt="Loading..."
                style={spinnerStyle}
            />
            <div style={messageStyle}>
                {message}
            </div>
        </div>
    );
};

